


















export default {
    name: "ModalLaboError",
    props: {
        title: String
        stacktrace: String
        message: String
    }
    methods:
        close: ()->
            console.log("CLOSE:")
            @$emit('closeModal')
            console.log("B")
}
